import { Form, InputNumber, Switch, Table } from "antd"
import { ColumnsType } from "antd/lib/table"
import Title from "antd/lib/typography/Title"
import { BP2InAppReviewConfigTriggerEnum, BP2InAppReviewConfigTriggerType } from "domains/managingJson/store/types"
import { FC } from "react"

interface Column {
    type: BP2InAppReviewConfigTriggerType,
}

const dataSource = Object.keys(BP2InAppReviewConfigTriggerEnum).sort().map(type => ({ type: type })) as Column[]

const columns: ColumnsType<Column> = [{
  key: "type",
  dataIndex: "type",
  title: "Trigger",
  render: type => (
    <span>
      {type}
    </span>
  ),
}, {
  key: "organic",
  title: "Trigger for Organic",
  render: (_, { type }) => {

    return (
      <Form.Item
        name={[
          "inAppReviews", "triggers", BP2InAppReviewConfigTriggerEnum[type], "organic",
        ]}
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
    )
  },
}, {
  key: "paid",
  title: "Trigger for Paid (Non-Organic)",
  render: (_, { type }) => {
    return (
      <Form.Item
        name={[
          "inAppReviews", "triggers", BP2InAppReviewConfigTriggerEnum[type], "paid",
        ]}
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
    )
  },
}]

const InAppReviews: FC = () => {
  return (
    <div style={{ marginBottom: "2rem" }}>
      <Title level={3}>
          In App Reviews
      </Title>
      <Form.Item
        name="reviewRequestsEnabled"
        label="Review Requests Enabled (GLOBAL)"
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
      <Form.Item
        name={["inAppReviews", "minSessions"]}
        label="Minimum number of sessions to become eligible"
      >
        <InputNumber min={0} step={1} />
      </Form.Item>
      <Form.Item
        name={["inAppReviews", "cooldownDays"]}
        label="Cooldown period between triggers in days"
      >
        <InputNumber min={0} step={1} />
      </Form.Item>
      <Table<Column>
        columns={columns}
        dataSource={dataSource}
        rowKey="type"
        pagination={false}
      />
    </div>
  )
}

export default InAppReviews
